import React from 'react';
import { Grid, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  dealersDiv: {
    maxHeight: '8%',
    height: '8%',
  },
  dealershipsContainer: {
    display: 'flex',
    padding: '12px',
    alignItems: 'flex-start',
    alignSelf: 'strech',
    gap: '16px',
    borderRadius: '8px',
    border: '1px solid var(--brand-200, #D9D6FE)',
    background: 'var(--brand-50, #FFFFFF)',
    maxHeight: '30%',
    height: '30%',
  },
  stepInnerContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  stepDealershipsDesc: {
    fontFamily: 'Montserrat',
    color: '#10182B',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '15px',
    marginLeft: '8px',
  },
}));

export default function DealershipHeader() {
  const classes = useStyles();

  return (
    <div className={classes.dealersDiv}>
      <div className={classes.dealershipsContainer}>
        <Grid container>
          <Grid item xs={4}>
            <Grid className={classes.stepInnerContainer} container direction="row">
              <Grid item>
                <Grid container direction="column">
                  <Grid item className={classes.stepDealershipsDesc}>
                    Dealerships
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={4} style={{borderLeft: '2px solid #D9D6FE'}}>
            <Grid className={classes.stepInnerContainer} container direction="row">
              <Grid item>
                <Grid container direction="column">
                  <Grid item className={classes.stepDealershipsDesc}>
                    Departments
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={4} style={{borderLeft: '2px solid #D9D6FE'}}>
            <Grid className={classes.stepInnerContainer} container direction="row">
              <Grid item>
                <Grid container direction="column">
                  <Grid item className={classes.stepDealershipsDesc}>
                    Roles
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}
